// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionWidth: 300,
		suggestionPosition: 'left',
		suggestionStyle2MainContainerSelector: 'body' // for style2
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
		
		if (jQ('.mfp-wrap').length > 0) {
			jQ(suggestionElement).parent().css({
				'position': 'fixed',
			});
			jQ(suggestionElement).css({
				'overflow-y': 'scroll',
				'height': '300px'
			});
		}
	};
})();